import React, { useContext } from 'react';
import DocumentUploadContext from '../../context/DocumentUpload/documentUploadContext';
import Main from '../../pages/Main';
import Upload from '../../pages/Upload';
import Acknowledgement from '../../pages/Acknowledgement';
import NoticePage from '../../pages/NoticePage';
const DocumentUploadForm = () => {
  const documentUploadContext = useContext(DocumentUploadContext);
  switch (documentUploadContext.step) {
    case 0:
      return <Main />;
    case 1:
      return <Upload />;
    case 2:
      return <Acknowledgement />;
    case 3:
      return <NoticePage />;
    default:
      return <h1>{''}</h1>;
  }
};
export default DocumentUploadForm;
